export default __webpack_public_path__ + "static/media/churn_send_videos_by_email.f4e66817.gif";